// extracted by mini-css-extract-plugin
var _1 = "RichText_disabled__b4bc5";
var _2 = "RichText_editable__a8c92";
var _3 = "RichText_pseudoSelection__58e1f";
var _4 = "RichText_root__76872";
export { _1 as "disabled", _2 as "editable", _3 as "pseudoSelection", _4 as "root" }
